import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, mergeProps as _mergeProps, vShow as _vShow } from "vue"

const _hoisted_1 = { class: "contentHeader flex" }
const _hoisted_2 = { class: "contentBox" }
const _hoisted_3 = { class: "block w-full" }
const _hoisted_4 = { class: "flex mb-4" }
const _hoisted_5 = ["title"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "icon-neu" }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = ["disabled", "title"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "icon-loeschen" }, null, -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "ml-auto" }
const _hoisted_12 = { class: "text-center" }

import {onBeforeUnmount, onMounted, reactive, ref} from "vue";
import { BryntumGrid } from "@bryntum/grid-vue-3";
import { Menu, Store } from "@bryntum/grid";
import GridInputFilter from "@/components/GridInputFilter.vue";
import {useGlobalStore} from "@/stores/GlobalStore";
import {ErrorLocationType, PopupType, TableType} from '@/utilities/enums/Enums';
import ErrorHandler from "@/utilities/helpers/ErrorHandler";
import FilterService from "@/utilities/services/FilterService";
import {PermissionService} from "@/utilities/services/PermissionService";
import {GeneralResponse} from "@/models/api/Responses";
import {LevelInfo} from "@/models/group2/LevelInfo";
import dialog from "@/dialog";
import {useI18n} from "vue-i18n";
import {checkboxColumnConfig, defaultSpaceAroundTableOnPage} from "@/AppConfig";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import { $t } from "@/utilities/i18n/config";
import Error from "@/components/Error.vue";
import {Group2Service} from "@/utilities/services/entities/Group2Service";



export default /*#__PURE__*/_defineComponent({
  __name: 'Group2',
  setup(__props) {

const { t } = useI18n();

const gridStore = new Store();
const globalStore = useGlobalStore();

let selectedLevels = ref([]);
const group2Service = new Group2Service();
const permissionService = new PermissionService();

const deleteSelection = async() => {
  //drop call without selection
  if(!selectedLevels.value?.some(()=>true)) return;

  const answer = await dialog
      .okText(t('global.delete'))
      .cancelText(t('global.cancel'))
      .confirm(t('levels.confirmDeletionMulti', {count:selectedLevels.value.length}));

  if (answer) {
    let someEntriesFailed = false;
    for (const level of selectedLevels.value){
      const resp = await group2Service.deleteLevel(level.id);

      if(resp === null || resp === undefined || resp?.statusCode !== 0){
        ErrorHandler.handleError(resp, ErrorLocationType.table);
        someEntriesFailed = true;
        continue;
      }

      gridStore.applyChangeset({removed:[{id:level.id}]});
    }

    if (someEntriesFailed) return;

    globalStore.showSuccess(t("global.deleted"));
  }
};

const currentWindowHeight = ref("");
const recalcGridHeight = () => {
  currentWindowHeight.value = `${window.innerHeight-defaultSpaceAroundTableOnPage}px`;
};

const grid = ref(null);
const useGridConfig = {
  headerMenuFeature: false,
  enableTextSelection: true,
  height: currentWindowHeight,
  selectionMode : {
    row	  : true,
    checkbox: checkboxColumnConfig,
    showCheckAll : true,
    deselectFilteredOutRecords: true
  },
  columns : {
    data: [
      { id:'id', field : 'id', text: t('levels.grid.id'), width   : 100 },
      { id:'name', field : 'name', text: t('levels.grid.description'), flex : 1 },
      {
        id:'locations',
        field : 'locations',
				sortable: false,
        text: '',
        width: 36,
        type: 'template',
        template: ({ record }:any) => {
					if(record.data.locations.length > 0)
						return `<div class='gridRowButton'><span class='icon-pin_outline'></span></div>`;
					return
				},
      },
      {
        id:'menu',
        text	: '',
        width   : 36,
        type	: 'widget',
        align: "center",
        hideable: false,
        resizable: false,
        sortable: false,
        filterable: false,
        widgets : [{
          type	 : 'button',
          width: 36,
          icon	 : 'icon-kontext_horizontal',
          onAction : ({ source: btn }) => {
            const menu = menuFactory(btn.cellInfo.record.data);
            //menu.setRecord(btn.cellInfo.record.data);
            menu.alignTo({ target: btn })
            menu.show();
          }
        }]
      },
    ],
    listeners:{
      async add(event:any){
        if(event.records.length === 1 && event.isMove[event.records[0].id]){
          await globalStore.saveUserColumnOrder(TableType[TableType.group2], event.records[0].id, event.index.toString());
        }
      },
    }
  },
  store: gridStore,
  listeners: {
    selectionChange(event) {
      if(event.selection.length > 0 && event.selection[0]?.data === undefined) return;
      selectedLevels.value = selectedLevels.value.concat(event.selected.map(lr => lr.data));
      selectedLevels.value = selectedLevels.value.filter(l => !event.deselected.map(lr => lr.data).some(lr => l?.id === lr?.id));
    },
    datachange(){
      globalStore.currentItems = gridStore.count;
      globalStore.allItems = gridStore.originalCount;
    },
    cellClick({column, record}) {
      if (column.data.field === 'locations' && record.data.locations.length > 0) {
        globalStore.openPopup({
          data: record.data, // Need locations or LevelId
          action:globalStore.closeModal,
          title: "Standorte",
          type: PopupType.group2Locations
        });
      }
    }
  },
}


const menuFactory = (record:object) => {
  const menu = new Menu({
    anchor   : true,
    autoShow : true,
    items	: [
      {
        text: t('global.edit'),
        cls: 'color',
        icon: 'icon-editieren',
        hidden: !permissionService.userHasPermission("Region.Edit"),
        weight: 100,

        onItem : async ({ menu }) => {
          // Add item processing here
          globalStore.openPopup({
            data: menu.record,
            action:addOrUpdateLevel,
            title: $t('levels.edit'),
            type: PopupType.group2Popup
          });

        }
      },
      {
        text   : t('global.delete'),
        cls    : 'color',
        hidden: !permissionService.userHasPermission("Region.Delete"),
        icon: 'icon-loeschen',
        weight : 140,
        onItem: async ({ menu }) => {
          const answer = await dialog
              .okText(t('global.delete'))
              .cancelText(t('global.cancel'))
              .confirm(t('levels.confirmDeletionSingle', {name:menu.record.name}));

          if (answer) {
            const resp = await group2Service.deleteLevel(menu.record.id);

            if(resp === null || resp === undefined || resp?.statusCode !== 0){
              ErrorHandler.handleError(resp, ErrorLocationType.table);
              return;
            }

            gridStore.applyChangeset({removed:[{id:menu.record.id}]});

            globalStore.showSuccess(t('levels.deleted'));
          }
        }
      }
    ],
  });

  menu.setRecord(record);

  return menu;
};

const gridConfig = reactive(useGridConfig);


const newGroup2 = () => {
  const level = new LevelInfo();

  globalStore.openPopup({
    data: level,
    action:addOrUpdateLevel,
    title: t('levels.new'),
    type: PopupType.group2Popup
  });

}

const addOrUpdateLevel = async () => {
  const level = globalStore.modal.contentObject as LevelInfo;

  const createResp = await group2Service.addOrUpdateLevel(level);
  if (createResp === null || createResp === undefined || createResp.statusCode !== 0){
    ErrorHandler.handleError(createResp as GeneralResponse, ErrorLocationType.popup);
    return;
  }

  if(level.id < 0) level.id = createResp.id;
  // fix selection when it was an update -> replace old value in selected-array
  else if(selectedLevels.value.some(el => el.id === level.id)) {
    selectedLevels.value = selectedLevels.value.filter(el => el.id !== level.id);
    selectedLevels.value.push(level);
  }

  // in case of an update bryntum automatically replaces the entry with the same ID
  gridStore.add(level);
  // reapply sorting
  gridStore.sort(gridStore.sorters);
  // reapply filtering
  gridStore.filter({
    id: "userFilter",
    filterBy: FilterService.buildFilter(TableType[TableType.user])
  });

  globalStore.closeModal();
  globalStore.showSuccess('Gespeichert');
}

const setGridData = async ()=>{
  // start spinner
  globalStore.gridDataIsLoading = true;

  const levels = await group2Service.getLevels("display");

  if (levels === null || levels === undefined || levels.statusCode !== 0) {
    ErrorHandler.handleError(levels, ErrorLocationType.table);
    return;
  }

  gridStore.setStoreData(levels.levelInfo);

  globalStore.reorderColumns(TableType[TableType.group2]);

  globalStore.closeModal();
  // stop spinner
  globalStore.gridDataIsLoading = false;
};

onMounted(async () => {
  // calculate grid height and sub to window resize event
  recalcGridHeight();
  window.addEventListener('resize', recalcGridHeight);

  globalStore.setGridStore(ref(gridStore));
  globalStore.setGridColumnStore(ref(grid.value?.instance.value?.columns));

  await setGridData();
})

onBeforeUnmount(()=>{
  window.removeEventListener('resize', recalcGridHeight);

  globalStore.setGridStore(null);
  globalStore.setGridColumnStore(null);

  globalStore.currentItems = 0;
  globalStore.allItems = 0;
});

return (_ctx: any,_cache: any) => {
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h4", null, _toDisplayString(_unref($t)('levels.title')), 1)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("div", null, [
        _createVNode(Error, {
          errorLoc: _unref(ErrorLocationType).table
        }, null, 8, ["errorLoc"]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _withDirectives((_openBlock(), _createElementBlock("button", {
              class: "primary mr-2",
              onClick: newGroup2,
              title: _unref($t)('levels.new')
            }, _hoisted_7, 8, _hoisted_5)), [
              [_directive_permission, 'Region.Create']
            ]),
            _withDirectives((_openBlock(), _createElementBlock("button", {
              class: "primary mr-2",
              disabled: !_unref(selectedLevels).some(()=>true),
              onClick: deleteSelection,
              title: _unref(t)('global.delete')
            }, _hoisted_10, 8, _hoisted_8)), [
              [_directive_permission, 'Region.Delete']
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(GridInputFilter, {
                gridStore: _unref(gridStore),
                popupType: _unref(PopupType).userFilterPopup,
                hideFilterButton: true
              }, null, 8, ["gridStore", "popupType"])
            ])
          ]),
          _createVNode(_unref(BryntumGrid), _mergeProps({
            ref_key: "grid",
            ref: grid
          }, gridConfig, { readOnly: true }), null, 16)
        ])
      ], 512), [
        [_vShow, !_unref(globalStore).gridDataIsLoading]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_12, [
        _createVNode(LoadingSpinner)
      ], 512), [
        [_vShow, _unref(globalStore).gridDataIsLoading]
      ])
    ])
  ]))
}
}

})